import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { canSeeExtendedLogs } from '@/components/Campaigns/assets/EventFilter/helperFunctions';
import { DateOptionsInterface } from '@/components/Campaigns/CampaignsInterface';
import {
    TIME_RANGE_1_DAY,
    TIME_RANGE_35_DAYS,
    TIME_RANGE_3_DAYS,
    TIME_RANGE_TWO_WEEKS,
    TIME_RANGE_WEEK,
} from '@/services/constants';
import { useMobile } from '@/services/hooks/useMobile';
import { getAccountStore } from '@/store/account/actions';
import { DateDropdownOptions } from '@/services/dictionaries/DateRangeValues';

/**
 * @returns dates options for dateDropdown popover
 */
export const useDateDropdownOptions = (): DateOptionsInterface[] => {
    const { t } = useTranslation();
    const isMobile = useMobile();
    const { GeneralInfo } = useSelector(getAccountStore);
    const logsDays = GeneralInfo?.KeepLogsForDays === TIME_RANGE_3_DAYS ? TIME_RANGE_3_DAYS : TIME_RANGE_WEEK;
    const calendarOption = { label: t('specifictimerange'), value: DateDropdownOptions.Calendar };
    const filterData = [
        { label: t('last24hours'), value: TIME_RANGE_1_DAY.toString() },
        { label: t('lastxdays', { days: logsDays }), value: logsDays.toString() },
    ];

    canSeeExtendedLogs(GeneralInfo?.AccountAccessLevel) &&
        filterData.push(
            { label: t('last14days'), value: TIME_RANGE_TWO_WEEKS.toString() },
            { label: t('last35days'), value: TIME_RANGE_35_DAYS.toString() }
        );

    if (isMobile) {
        return [...filterData, calendarOption];
    }
    return [calendarOption, ...filterData];
};
